import React, { Component } from "react";
import { Modal, Button, Row, Col } from "antd";

export default class DeleteConfirmationModal extends Component {
  render() {
    const {
      showDeleteModal,
      toggleDeleteModal,
      handleDeletion,
      isProcessing,
      modalTitle,
      modalMessage
    } = this.props;
    return (
      <Modal
        title={modalTitle}
        visible={showDeleteModal}
        footer={null}
        className="kc-modal-medium no-footer"
        onCancel={toggleDeleteModal}
      >
        <p>{modalMessage}</p>

        <Row className="modal-footer-row" type="flex">
          <Col>
            <Button
              type="primary"
              size="small"
              onClick={handleDeletion}
              loading={isProcessing}
            >
              {"Delete"}
            </Button>
            <Button size="small" onClick={toggleDeleteModal}>
              {"Cancel"}
            </Button>
          </Col>
        </Row>
      </Modal>
    );
  }
}
